function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: 0,
  y: 0,
  width: 82,
  height: 82,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#b4b4b4",
  floodOpacity: 0.471
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-554 -4907)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 554, 4907)",
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 6)",
  fill: "#27d3c5",
  stroke: "#e4e4e6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 8,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 63,
  height: 63,
  rx: 7.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(568.5 4918.5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 53,
  height: 53,
  rx: 8,
  transform: "translate(0.5 0.5)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.5 4.5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 45,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5,21.167a2.778,2.778,0,0,1-2.778,2.778H10.056L4.5,29.5V7.278A2.778,2.778,0,0,1,7.278,4.5H26.722A2.778,2.778,0,0,1,29.5,7.278Z",
  transform: "translate(5.5 5.5)",
  fill: "#fff"
}))));

var SvgSmsSent = function SvgSmsSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmsSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SMSSent.c8e6edd3.svg";
export { ForwardRef as ReactComponent };